<template>
    <svg aria-hidden="true" focusable="false" width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 0.5L1 5.5L6 10.5" stroke="black" />
    </svg>
</template>
